import React from 'react'
import NoOfferImage from '../../img-offer/NoOfferImage.png'
import { Box, Typography } from '@mui/material'

export default function NoOfferYetCreated({message , content}) {
  return (
    <Box p={4}>
    <Box display={'flex'} justifyContent={'center'} alignItems={'center'} flexDirection={'column'}>
        <img src={NoOfferImage} alt='No Image Found' style={{width:'240px' , height:'200px'}} />
        <Box justifyContent={'center'} textAlign={'center'} sx={{width:'518px' , p: 2}}>
            <Typography sx={{fontSize:'30px' , color:'#4C4E64DE' , fontWeight:700}}>{message} </Typography>
            <Typography sx={{fontSize:'18px' , color:'#A6A6A6' , fontWeight:400}}>{content}</Typography>
        </Box>
    </Box>
    </Box>
  )
}
